import {
	feedbackWidgetSlice,
	NotificationListModel,
	notificationListSlice,
	WidgetDataModel,
} from 'Modules'
import { massUpdateCuratorSlice } from 'Pages/pp'
import { leadsSlice } from 'Pages/lead'
import { ChannelHandler, SocketMessage, SocketMessageTypes } from 'Modules/Socket'
import { Callback } from 'Src/types/utilTypes'
import { ordersSlice } from 'Pages/orders_design'

export class NotificationChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}
	public work(data: SocketMessage) {
		const { message } = data

		const recognition_data = message?.payload?.recognition_data

		if (message?.type === SocketMessageTypes.MASS_UPDATE_LEADS_FINISHED) {
			this.dispatch(leadsSlice.actions.socketMassUpdateLeadsIds())
		}
		if (message?.type === SocketMessageTypes.NOTIFICATION && message?.payload?.id) {
			const notification = Object.assign(new NotificationListModel(), { ...message?.payload })
			this.dispatch(notificationListSlice.actions.getMessage(notification))
		}
		if (message?.type === SocketMessageTypes.MASS_UPDATE_PARTNER) {
			this.dispatch(
				massUpdateCuratorSlice.actions.getAllSocket({
					source_manager_id: message?.payload?.source_manager_id,
				})
			)
		}
		if (message?.type === SocketMessageTypes.CSAT_NOTIFICATION) {
			this.dispatch(
				feedbackWidgetSlice.actions.setFeedbackWidget(message?.payload as WidgetDataModel)
			)
		}
		if (message?.payload?.recognition_data) {
			const order_id = message?.payload?.order_id
			// @ts-ignore
			this.dispatch(ordersSlice.actions.setRecognizedData({ recognition_data, order_id }))
			this.dispatch(ordersSlice.actions.setRecognizeLoading(false))
		}
	}
}
